<template>
  <div>
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex xs12 offset-sm6
            class="text-xs-right"
          >
            <v-btn
              color="primary"
              :loading="loadingExportData"
              :disabled="loadingExportData"
              flat
              @click="download()"
            >
              {{ $t('exportInCsv') }}
              <v-icon color="primary" right>file_download</v-icon>
            </v-btn>
            <v-btn
              color="primary"
              :loading="loadingExportData"
              :disabled="loadingExportData"
              flat
              @click="displayAllStats()"
              v-if="oneStatHidden"
            >
              voir toutes les stats
              <v-icon color="primary" right>analytics</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <!-- Nombre total de chats -->
          <v-flex xs12 sm6 md4>
            <v-card>
              <v-card-text v-if="loading" class="text-xs-center pt-3">
                <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
              </v-card-text>
              <v-container v-else>
                <v-layout row wrap>
                  <v-flex xs12>
                    <div>
                      <div class="subheading text-xs-center">Conversations</div>
                    </div>
                  </v-flex>
                  <v-flex xs12 class="primary--text display-1 text-xs-center">
                    {{ chatsOK }}
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>

          <!-- Durée moyenne des chats -->
          <v-flex xs12 sm6 md4>
            <v-card>
              <v-card-text v-if="loading" class="text-xs-center pt-3">
                <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
              </v-card-text>
              <v-container v-else>
                <v-layout row wrap>
                  <v-flex xs12>
                    <div>
                      <div class="subheading text-xs-center">Durée moyenne</div>
                    </div>
                  </v-flex>
                  <v-flex xs12 class="primary--text display-1 text-xs-center">
                    {{ averageDurationFormatted }}
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>

          <!-- nb bulles  -->
          <v-flex xs12 sm6 md4>
            <v-card>
              <v-card-text v-if="loading" class="text-xs-center pt-3">
                <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
              </v-card-text>
              <v-container v-else>
                <v-layout row wrap>
                  <v-flex xs12>
                    <div>
                      <div class="subheading text-xs-center">Messages par conversation</div>
                    </div>
                  </v-flex>
                  <v-flex xs12 class="primary--text display-1 text-xs-center">
                    {{ nbMessages }}
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>

          <!-- Nombre de widget ouvert -->
          <v-flex xs12 sm6 md4>
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                class="mx-auto"
                color="grey lighten-4"
                max-width="600"
                height="550"
              >
                 <v-card-text v-if="loading" class="text-xs-center pt-3">
                   <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
                 </v-card-text>
                 <v-container v-else>
                   <v-layout row wrap>
                     <v-flex xs12>
                       <div>
                         <div class="subheading text-xs-center">Chatbots consultés</div>
                       </div>
                     </v-flex>
                     <v-flex xs12 class="primary--text display-1 text-xs-center">
                       {{ nbOpen }}
                     </v-flex>
                   </v-layout>
                   <v-expand-transition>
                     <div
                                   
                       class="transition-fast-in-fast-out v-card--reveal text-xs"
                       style="height: 100%;"
                     >
                       <v-card v-if="loading" class="mb-3" height="360px">
                         <v-card-text class="text-xs-center pt-5">
                           <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
                         </v-card-text>
                       </v-card>
                       <v-card v-else class="mb-3 text-md-center" height="360px">
                         <highcharts :options="graphOpening"></highcharts>
                         <span>- Nb de visiteurs uniques l'ayant ouvert : {{ nbDistinctOpen }}</span><br>
                         <span>- Nb total de questions posées (messages avec "?") : {{ nbQuestions }}</span><br>
                         <span>- Nb total de recherche (messages avec "cherche") : {{ nbCherche }}</span><br>
                       </v-card>
                     </div>
                   </v-expand-transition>
                 </v-container>        
                 <v-card-text
                   class="pt-0"
                   style="position: relative;"
                 >
                   <div class="font-weight-light grey--text mb-2">C'est le nombre total des formulaires validés (ceux du volet latéral) + Prises de rendez vous + Rappels/callback, tous visiteurs confondus</div>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-flex>

          <!-- Nombre de card poussées -->
          <v-flex xs12 sm6 md4 v-if="isThereCarrousel">
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                class="mx-auto"
                color="grey lighten-4"
                max-width="600"
                height="550"
              >
                 <v-card-text v-if="loading" class="text-xs-center pt-3">
                   <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
                 </v-card-text>
                 <v-container v-else>
                   <v-layout row wrap>
                     <v-flex xs12>
                       <div>
                         <div class="subheading text-xs-center">Carrousels proposés</div>
                       </div>
                     </v-flex>
                     <v-flex xs12 class="primary--text display-1 text-xs-center">
                       {{ nb_carousel }}
                     </v-flex>
                   </v-layout>
                   <v-expand-transition>
                     <div
                                   
                       class="transition-fast-in-fast-out v-card--reveal text-xs"
                       style="height: 100%;"
                     >
                       <highcharts :options="jaugeCarousels"></highcharts><br>
                       <span>- Nb de visiteurs uniques ayant eu au moins un carrousel : {{ nbVisWithCarrousel }}</span><br>
                       <span>- Nb moy. de carrousel par visiteur : {{ nbCarouselsPerVis }}</span>
                     </div>
                   </v-expand-transition>
                 </v-container>        
                 <v-card-text
                   class="pt-0"
                   style="position: relative;"
                 >
                   <div class="font-weight-light grey--text mb-2">C'est le nombre total de fois où le bot à montré un carrousel de résultats, tous visiteurs confondus</div>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-flex>

          <!-- Nombre de CTA cliqués -->
          <v-flex xs12 sm6 md4 v-if="isThereCTA">
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                class="mx-auto"
                color="grey lighten-4"
                max-width="600"
                height="550"
              >
                 <v-card-text v-if="loading" class="text-xs-center pt-3">
                   <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
                 </v-card-text>
                 <v-container v-else>
			     
                   <v-layout row wrap>
                     <v-flex xs12>
                       <div>
                         <div class="subheading text-xs-center">CTA cliqués</div>
                       </div>
                     </v-flex>
                     <v-flex xs12 class="primary--text display-1 text-xs-center">
                       {{ nb_cta }}
                     </v-flex>
                   </v-layout>
                   <v-expand-transition>
                     <div
                                   
                       class="transition-fast-in-fast-out v-card--reveal text-xs"
                       style="height: 100%;"
                     >
                        <v-card height="300">
                          <highcharts :options="optionsCta"></highcharts>
                        </v-card>

                     </div>
                   </v-expand-transition>
                 </v-container>        
                 <v-card-text
                   class="pt-0"
                   style="position: relative;"
                 >
                   <div class="font-weight-light grey--text mb-2">C'est le nombre total de click sur les CTA : ceux présents sur les vignettes produits des carrousels (devis / brochure / panier ...), tous visiteurs confondus</div>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-flex>
         
          <!-- Nombre de Transferts -->
          <v-flex xs12 sm6 md4 v-if="isThereTransfert">
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                class="mx-auto"
                color="grey lighten-4"
                max-width="600"
                height="550"
              >
                 <v-card-text v-if="loading" class="text-xs-center pt-3">
                   <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
                 </v-card-text>
                 <v-container v-else>
			     
                   <v-layout row wrap>
                     <v-flex xs12>
                       <div>
                         <div class="subheading text-xs-center">Transferts multicanaux</div>
                       </div>
                     </v-flex>
                     <v-flex xs12 class="primary--text display-1 text-xs-center">
                       {{ nb_transferts }}
                     </v-flex>
                   </v-layout>
                   <v-expand-transition>
                     <div
                                   
                       class="transition-fast-in-fast-out v-card--reveal text-xs"
                       style="height: 100%;"
                     >
                       <v-card v-if="loading" class="mb-3" height="360px">
                         <v-card-text class="text-xs-center pt-5">
                           <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
                         </v-card-text>
                       </v-card>
                       <v-card v-else class="mb-3 text-md-center" height="360px">
                         <highcharts :options="graphTransfert"></highcharts>
                         <span>'Chat live' : {{nb_transfertchat}}</span><br />
                         <span>'Rappels/Callback' : {{nb_transferttel}}</span><br />
                         <span>'Formulaires de contact' : {{nb_transfertemail}}</span><br />
                         <span>'Prises de Rendez-vous' : {{nb_transfertmeeting}} </span><br />
                       </v-card>

                     </div>
                   </v-expand-transition>
                 </v-container>        
                 <v-card-text
                   class="pt-0"
                   style="position: relative;"
                 >
                   <div class="font-weight-light grey--text mb-2">C'est le nombre total de click sur les boutons de transfert multicanal des bulles de chat (tous visiteurs confondus)</div>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-flex>
          <!-- Nombre de Lead -->
          <v-flex xs12 sm6 md4 v-if="isThereConversion">
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                class="mx-auto"
                color="grey lighten-4"
                max-width="600"
                height="550"
              >
                 <v-card-text v-if="loading" class="text-xs-center pt-3">
                   <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
                 </v-card-text>
                 <v-container v-else>
        
                   <v-layout row wrap>
                     <v-flex xs12>
                       <div>
                         <div class="subheading text-xs-center">Conversions</div>
                       </div>
                     </v-flex>
                     <v-flex xs12 class="primary--text display-1 text-xs-center">
                       {{ nb_formok + nb_meetingok + nb_c2cok }}
                     </v-flex>
                   </v-layout>
                   <v-expand-transition>
                     <div
                                   
                       class="transition-fast-in-fast-out v-card--reveal text-xs"
                       style="height: 100%;"
                     >
                       <v-card v-if="loading" class="mb-3" height="360px">
                         <v-card-text class="text-xs-center pt-5">
                           <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
                         </v-card-text>
                       </v-card>
                         <v-card v-else class="mb-3 text-md-center" height="360px">
                         <highcharts :options="graphConversion"></highcharts>
                         <span>- Nb de Callback effectués : {{ nb_c2cok }}</span><br>
                         <span>- Nb de Meeting bookés : {{ nb_meetingok }}</span><br>
                         <span>- Nb de Formulaires validés : {{ nb_formok }}</span><br>
                                                                                              
                       </v-card>
                     </div>
                   </v-expand-transition>
                 </v-container>        
                 <v-card-text
                   class="pt-0"
                   style="position: relative;"
                 >
                   <div class="font-weight-light grey--text mb-2">C'est le nombre total des formulaires validés (ceux du volet latéral) + Prises de rendez vous + Rappels/callback, tous visiteurs confondus</div>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-flex>

          <!-- Exemple d'accueil cliqués -->
          <v-flex xs12 sm6 md4 v-if="isThereAccueil">
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                class="mx-auto"
                color="grey lighten-4"
                max-width="600"
                height="550"
              >
                 <v-card-text v-if="loading" class="text-xs-center pt-3">
                   <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
                 </v-card-text>
                 <v-container v-else>
			     
                   <v-layout row wrap>
                     <v-flex xs12>
                       <div>
                         <div class="subheading text-xs-center">Messages d'accueil cliqués</div>
                       </div>
                     </v-flex>
                     <v-flex xs12 class="primary--text display-1 text-xs-center">
                       {{ nb_accueil }}
                     </v-flex>
                   </v-layout>
                   <v-expand-transition>
                     <div
                                   
                       class="transition-fast-in-fast-out v-card--reveal text-xs"
                       style="height: 100%;"
                     >
                        <v-card height="300">
                          <highcharts :options="optionsAccueil"></highcharts>
                        </v-card>
                     </div>
                   </v-expand-transition>
                 </v-container>        
                 <v-card-text
                   class="pt-0"
                   style="position: relative;"
                 >
                   <div class="font-weight-light grey--text mb-2">C'est le nombre total des messages d'exemple cliqués, tous visiteurs confondus</div>
                </v-card-text>
              </v-card>
              <v-layout row v-if="nb_like > 0">
                <v-flex xs12 sm8 offset-sm3>
                  <v-card>
                   <v-list class="fixed-height-list" dense>
                      <v-list-tile
                        v-for="item in likesSessid"
                        :key="item"
                        @click="dialogLike = true ; editThisGuy = item"
                      >
                        <v-list-tile-content>
                          <v-list-tile-title>{{ item }}</v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-btn icon ripple>
                            <v-icon color="grey lighten-1">info</v-icon>
                          </v-btn>
                        </v-list-tile-action>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-hover>
          </v-flex>

          <!-- Top produits consultées -->
          <v-flex xs12 sm6 md4 v-if="isThereTop10">
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                class="mx-auto"
                color="grey lighten-4"
                max-width="600"
                height="550"
              >
                 <v-card-text v-if="loading" class="text-xs-center pt-3">
                   <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
                 </v-card-text>
                 <v-container v-else>
                   <v-layout row wrap>
                     <v-flex xs12>
                       <div>
                         <div class="subheading text-xs-center">Top 10 Produits consultés</div>
                       </div>
                     </v-flex>
                     <v-flex xs12 class="primary--text display-1 text-xs-center">
                       {{ nb_products }}
                     </v-flex>
                   </v-layout>
                   <v-expand-transition>
                     <div
                       class="transition-fast-in-fast-out v-card--reveal text-xs"
                       style="height: 100%;"
                     >
                        <v-card height="300">
                          <highcharts :options="optionsTop10"></highcharts>
                        </v-card>
                     </div>
                   </v-expand-transition>
                 </v-container>        
                 <v-card-text
                   class="pt-0"
                   style="position: relative;"
                 >
                   <div class="font-weight-light grey--text mb-2">C'est le nombre total de pages produits qui ont été cliquées depuis les carrousels, et affichées dans le volet latéral, tous visiteurs confondus</div>
                </v-card-text>
              </v-card>
              <v-layout row v-if="nb_products > 0">
                <v-flex xs12 sm8 offset-sm3>
                  <v-card>
                   <v-list class="fixed-height-list" dense>
                      <v-list-tile
                        v-for="item in likesSessid"
                        :key="item"
                      >
                        <v-list-tile-content>
                          <v-list-tile-title>{{ item }}</v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-btn icon ripple>
                            <v-icon color="grey lighten-1">info</v-icon>
                          </v-btn>
                        </v-list-tile-action>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-hover>
          </v-flex>

          <!-- Nombre de Like -->
          <v-flex xs12 sm6 md4>
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                class="mx-auto"
                color="grey lighten-4"
                max-width="600"
                height="550"
              >
                <v-card-text v-if="loading" class="text-xs-center pt-3">
                  <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
                </v-card-text>
                <v-container v-else>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <div>
                        <div class="subheading text-xs-center">Nb de like 👍</div>
                      </div>
                    </v-flex>
                    <v-flex xs12 class="primary--text display-1 text-xs-center">
                      {{ nb_like }}
                    </v-flex>
                  </v-layout>
                  <v-layout row v-if="nb_like > 0">
                    <v-flex xs12 sm12>
                      <v-card>
                       <v-list class="fixed-height-list" dense>
                          <v-list-tile
                            v-for="item in likesSessid"
                            :key="item"
                            @click="dialogLike = true ; editThisGuy = item"
                          >
                            <v-list-tile-content>
                              <v-list-tile-title>{{ item }}</v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                              <v-btn icon ripple>
                                <v-icon color="grey lighten-1">info</v-icon>
                              </v-btn>
                            </v-list-tile-action>
                          </v-list-tile>
                        </v-list>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-hover>
          </v-flex>
          <!-- Nombre de Unlike -->
          <v-flex xs12 sm6 md4>
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                class="mx-auto"
                color="grey lighten-4"
                max-width="600"
                height="550"
              >
                <v-card-text v-if="loading" class="text-xs-center pt-3">
                  <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
                </v-card-text>
                <v-container v-else>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <div>
                        <div class="subheading text-xs-center">Nb de unlike 👎</div>
                      </div>
                    </v-flex>
                    <v-flex xs12 class="primary--text display-1 text-xs-center">
                      {{ nb_unlike }}
                    </v-flex>
                  </v-layout>
                  <v-layout row v-if="nb_unlike > 0">
                    <v-flex xs12 sm12>
                      <v-card>
                       <v-list class="fixed-height-list" dense>
                          <v-list-tile
                            v-for="item in unlikesSessid"
                            :key="item"
                            @click="dialogLike = true ; editThisGuy = item"
                          >
                            <v-list-tile-content>
                              <v-list-tile-title>{{ item }}</v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                              <v-btn icon ripple>
                                <v-icon color="grey lighten-1">info</v-icon>
                              </v-btn>
                            </v-list-tile-action>
                          </v-list-tile>
                        </v-list>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-hover>
          </v-flex>
          <!-- Graphiques jauges Chats -->
<!--
          <v-flex xs12 sm6 md4>
            <v-card class="mb-3" :height="heightOfJauge">
              <v-card-text v-if="loading" class="text-xs-center pt-5">
                <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
              </v-card-text>
              <highcharts v-else :options="chatsMissed"></highcharts>
            </v-card>
          </v-flex>
-->
        </v-layout>

        <!-- Bouton affcihe/cache les historiques des chats visible uniquement pour les start, pro, entreprise -->
        <span>
          <v-btn flat @click="filterShortChats()" color="accent" v-if="!histoready">
            Afficher les conversations riches (> 1 message)
            <v-icon right>filter_alt</v-icon>
          </v-btn>
          <v-btn flat @click="showChats()" color="accent" v-if="histoready">
            {{ $t('hideChat') }}
            <v-icon right>visibility_off</v-icon>
          </v-btn>
          <v-btn flat @click="getChats()" color="accent" v-else>
             Afficher toutes les conversations
            <v-icon right>visibility</v-icon>
          </v-btn>
        </span>

        <!-- Historique des chats -->
        <wz-histo-chats
          :params="params"
          :numChatsTotal="String(chatsOK)"
          :filterChats="filterChats"
          v-if="histoready"
        ></wz-histo-chats>
      </v-container>

    <!-- DIALOGUES VOIS LIKE-->
    <v-dialog
      v-model="dialogLike"
      max-width="1200px"
      :scrollable="!$vuetify.breakpoint.smAndDown"
      :fullscreen="$vuetify.breakpoint.smAndDown"
    >
        <v-card-text :style="!$vuetify.breakpoint.smAndDown ? 'height: calc(100vh - 210px);' : ''" class="pa-0">
          <wz-histo-chats
            v-if="editThisGuy !== ''"
            :params="'visId=' + editThisGuy"
            :numChatsTotal="String(0)"
            chatHeight="100%"
            type="satisfaction"
            scroll
          ></wz-histo-chats>
        </v-card-text>
    </v-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import json2csv from 'json2csv'
import 'moment-duration-format'
import { mapGetters, mapState } from 'vuex'

export default {
  data () {
    return {
      loading: false,
      loadingExportData: false,
      queryCounter: 0,
      chatsOK: 0,
      chatsTotalDuration: 0,
      chatsAverageDuration: 0,
      nbMessages: 0,
      nbQuestions: 0,
      nbCherche: 0,
      nbOpen: 0,
      nbDistinctOpen: 0,
      chatsAverageResponseValue: 0,
      chatsFirstResponseValue: 0,
      histoready: false,
      panel: [true, false],
      nb_cta: 0,
      nb_products: 0,
      nb_accueil: 0,
      nb_carousel: 0,
      nbCarouselsPerVis: 0,
      nbVisWithCarrousel: 0,
      nb_transferts: 0,
      nb_formok: 0,
      nb_meetingok: 0,
      nb_c2cok: 0,
      nb_like: 0,
      nb_unlike: 0,
      productConsult1: '',
      productConsult2: '',
      productConsult3: '',
      productConsult4: '',
      productConsult5: '',
      productConsult6: '',
      productConsult7: '',
      productConsult8: '',
      productConsult9: '',
      productConsult10: '',
      productConsultNb1: 0,
      productConsultNb2: 0,
      productConsultNb3: 0,
      productConsultNb4: 0,
      productConsultNb5: 0,
      productConsultNb6: 0,
      productConsultNb7: 0,
      productConsultNb8: 0,
      productConsultNb9: 0,
      productConsultNb10: 0,
      accueil1: '',
      accueil2: '',
      accueil3: '',
      accueil4: '',
      accueilNb1: 0,
      accueilNb2: 0,
      accueilNb3: 0,
      accueilNb4: 0,
      nb_cart: 0,
      nb_appel: 0,
      nb_form: 0,
      nb_brochure: 0,
      nb_visio: 0,
      nb_bonuseco: 0,
      nb_devis: 0,
      nb_transfertchat: 0,
      nb_transferttel: 0,
      nb_transfertemail: 0,
      nb_transfertmeeting: 0,
      accueil: {},
      likesSessid: [],
      unlikesSessid: [],
      dialogLike: false,
      isThereTransfert: true,
      isThereConversion: true,
      isThereCarrousel: true,
      isThereCTA: true,
      isThereTop10: true,
      isThereAccueil: true,
      oneStatHidden: false,
      filterChats: false,
      editThisGuy: '',
      // options générales pour les jauges
      jaugeCarousels: {
        chart: {
          type: 'solidgauge',
          height: 180
        },
        title: {
          style: {
            fontSize: '20px',
            fontFamily: '"Inconsolata", sans-serif'
          },
          text: 'Ratio carrousel / nb Vis'
        },
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        },
        pane: {
          size: '220',
          startAngle: -90,
          endAngle: 90,
          center: ['50%', '95%'],
          background: {
            backgroundColor: '#ddd',
            outerRadius: '100%',
            innerRadius: '90%',
            shape: 'arc',
            borderColor: 'transparent'
          }
        },
        tooltip: {
          enabled: false
        },
        yAxis: {
          min: 0,
          lineWidth: 0,
          minorTickInterval: null,
          tickAmount: 2,
          title: {
            text: ''
          },
          stops: [[0, '#009688']], // teal
          max: 100
        },
        plotOptions: {
          solidgauge: {
            innerRadius: '90%',
            dataLabels: {
              y: 5,
              borderWidth: 0,
              useHTML: true
            }
          }
        },
        series: [{
          data: [0],
          dataLabels: {
            format: `<div style="text-align:center;font-size:32px;color:` + this.$vuetify.theme.primary + `;">{y:.1f} %</span></div>`
          }
        }]
      },
      /**
       * Options des graphiques
       */
      optionsPie: {
        chart: {
          height: 300,
          type: 'pie',
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false
        },
        colors: [
          this.$vuetify.theme.tertiary,
          this.$vuetify.theme.error,
          this.$vuetify.theme.warning,
          this.$vuetify.theme.success
        ],
        tooltip: {
          headerFormat: '<b>{point.key}</b><br/>',
          pointFormat: '{point.percentage:.1f}%'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: false
            },
            showInLegend: true
          }
        },
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        },
        title: { text: '' },
        series: [{ data: {} }]
      },
      optionsTop10: {
        title: { text: 'Top 10 des pages produits les plus consultées' },
        series: [{ data: {} }]
      },
      optionsAccueil: {
        title: { text: 'Phrase d\'accueil la plus cliquée' },
        series: [{ data: {} }]
      },
      optionsCta: {
        title: { text: 'Intitulés des CTA cliqués' },
        series: [{ data: {} }]
      },
      graphTransfert: {
        chart: {
          type: 'solidgauge',
          height: '250px',
          events: {
            // render: this.renderGraph()
          }
        },

        title: {
          text: ''
        },

        tooltip: {
          borderWidth: 0,
          backgroundColor: 'none',
          shadow: false,
          useHTML: true,
          style: {
            fontSize: '16px'
          },
          pointFormat: '<div style="text-align: center;"><div style="font-size:0.7em; width:100%">{series.name}</div><div style="font-size:1.15em; color: {point.color}; font-weight: bold; width:100%">{point.y}%</div></div>',
          positioner: function (labelWidth) {
            return {
              x: (this.chart.chartWidth - labelWidth) / 2,
              y: (this.chart.plotHeight / 2) + 15
            }
          },
          shared: true
        },
        pane: {
          startAngle: 0,
          endAngle: 360,
          background: [{ // Track for Move
            outerRadius: '112%',
            innerRadius: '88%',
            // backgroundColor: '#3F51B5',
            backgroundColor: this.Highcharts.Color('#3F51B5')
              .setOpacity(0.3)
              .get(),
            borderWidth: 0
          }, { // Track for Exercise
            outerRadius: '87%',
            innerRadius: '63%',
            // backgroundColor: '#3F51B5',
            backgroundColor: this.Highcharts.Color('#8BC34A')
              .setOpacity(0.3)
              .get(),
            borderWidth: 0
          }, { // Track for Stand
            outerRadius: '62%',
            innerRadius: '38%',
            // backgroundColor: '#3F51B5',
            backgroundColor: this.Highcharts.Color('#9E9E9E')
              .setOpacity(0.3)
              .get(),
            borderWidth: 0
          }, { // Track for Stand
            outerRadius: '38%',
            innerRadius: '14%',
            // backgroundColor: '#3F51B5',
            backgroundColor: this.Highcharts.Color('pink')
              .setOpacity(0.3)
              .get(),
            borderWidth: 0
          }]
        },

        yAxis: {
          min: 0,
          max: 100,
          lineWidth: 0,
          tickPositions: []
        },
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        },

        plotOptions: {
          solidgauge: {
            dataLabels: {
              enabled: false
            },
            linecap: 'round',
            stickyTracking: false,
            rounded: true
          }
        },

        series: [{
          name: 'Chat live',
          data: [{
            color: '#3F51B5',
            // color: this.Highcharts.getOptions().colors[0],
            radius: '112%',
            innerRadius: '88%',
            y: 0
          }]
        }, {
          name: 'Callback',
          data: [{
            color: '#8BC34A',
            // color: this.Highcharts.getOptions().colors[1],
            radius: '87%',
            innerRadius: '63%',
            y: 0
          }]
        }, {
          name: 'Formulaires de contact',
          data: [{
            color: '#9E9E9E',
            // color: this.Highcharts.getOptions().colors[2],
            radius: '62%',
            innerRadius: '38%',
            y: 0
          }]
        }, {
          name: 'Prises de RDV',
          data: [{
            color: '#9E9E9E',
            // color: this.Highcharts.getOptions().colors[2],
            radius: '62%',
            innerRadius: '38%',
            y: 0
          }]
        }]
      },
      graphOpening: {
        chart: {
          type: 'solidgauge',
          height: '250px',
          events: {
            // render: this.renderGraph()
          }
        },

        title: {
          text: ''
        },

        tooltip: {
          borderWidth: 0,
          backgroundColor: 'none',
          shadow: false,
          useHTML: true,
          style: {
            fontSize: '16px'
          },
          pointFormat: '<div style="text-align: center;"><div style="font-size:0.7em; width:100%">{series.name}</div><div style="font-size:1.15em; color: {point.color}; font-weight: bold; width:100%">{point.y}%</div></div>',
          positioner: function (labelWidth) {
            return {
              x: (this.chart.chartWidth - labelWidth) / 2,
              y: (this.chart.plotHeight / 2) + 15
            }
          },
          shared: true
        },
        pane: {
          startAngle: 0,
          endAngle: 360,
          background: [{ // Track for Move
            outerRadius: '112%',
            innerRadius: '88%',
            // backgroundColor: '#3F51B5',
            backgroundColor: this.Highcharts.Color('#3F51B5')
              .setOpacity(0.3)
              .get(),
            borderWidth: 0
          }, { // Track for Exercise
            outerRadius: '87%',
            innerRadius: '63%',
            // backgroundColor: '#3F51B5',
            backgroundColor: this.Highcharts.Color('#8BC34A')
              .setOpacity(0.3)
              .get(),
            borderWidth: 0
          }, { // Track for Stand
            outerRadius: '62%',
            innerRadius: '38%',
            // backgroundColor: '#3F51B5',
            backgroundColor: this.Highcharts.Color('#9E9E9E')
              .setOpacity(0.3)
              .get(),
            borderWidth: 0
          }]
        },

        yAxis: {
          min: 0,
          max: 100,
          lineWidth: 0,
          tickPositions: []
        },
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        },

        plotOptions: {
          solidgauge: {
            dataLabels: {
              enabled: false
            },
            linecap: 'round',
            stickyTracking: false,
            rounded: true
          }
        },

        series: [{
          name: 'Chat live',
          data: [{
            color: '#3F51B5',
            // color: this.Highcharts.getOptions().colors[0],
            radius: '112%',
            innerRadius: '88%',
            y: 0
          }]
        }, {
          name: 'Callback',
          data: [{
            color: '#8BC34A',
            // color: this.Highcharts.getOptions().colors[1],
            radius: '87%',
            innerRadius: '63%',
            y: 0
          }]
        }, {
          name: 'Formulaires de contact',
          data: [{
            color: '#9E9E9E',
            // color: this.Highcharts.getOptions().colors[2],
            radius: '62%',
            innerRadius: '38%',
            y: 0
          }]
        }]
      },
      graphConversion: {
        chart: {
          type: 'solidgauge',
          height: '250px',
          events: {
            // render: this.renderGraph()
          }
        },

        title: {
          text: ''
        },

        tooltip: {
          borderWidth: 0,
          backgroundColor: 'none',
          shadow: false,
          useHTML: true,
          style: {
            fontSize: '16px'
          },
          pointFormat: '<div style="text-align: center;"><div style="font-size:0.7em; width:100%">{series.name}</div><div style="font-size:1.15em; color: {point.color}; font-weight: bold; width:100%">{point.y}%</div></div>',
          positioner: function (labelWidth) {
            return {
              x: (this.chart.chartWidth - labelWidth) / 2,
              y: (this.chart.plotHeight / 2) + 15
            }
          },
          shared: true
        },
        pane: {
          startAngle: 0,
          endAngle: 360,
          background: [{ // Track for Move
            outerRadius: '112%',
            innerRadius: '88%',
            // backgroundColor: '#3F51B5',
            backgroundColor: this.Highcharts.Color('#3F51B5')
              .setOpacity(0.3)
              .get(),
            borderWidth: 0
          }, { // Track for Exercise
            outerRadius: '87%',
            innerRadius: '63%',
            // backgroundColor: '#3F51B5',
            backgroundColor: this.Highcharts.Color('#8BC34A')
              .setOpacity(0.3)
              .get(),
            borderWidth: 0
          }, { // Track for Stand
            outerRadius: '62%',
            innerRadius: '38%',
            // backgroundColor: '#3F51B5',
            backgroundColor: this.Highcharts.Color('#9E9E9E')
              .setOpacity(0.3)
              .get(),
            borderWidth: 0
          }]
        },

        yAxis: {
          min: 0,
          max: 100,
          lineWidth: 0,
          tickPositions: []
        },
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        },

        plotOptions: {
          solidgauge: {
            dataLabels: {
              enabled: false
            },
            linecap: 'round',
            stickyTracking: false,
            rounded: true
          }
        },

        series: [{
          name: 'Callback',
          data: [{
            color: '#3F51B5',
            // color: this.Highcharts.getOptions().colors[0],
            radius: '112%',
            innerRadius: '88%',
            y: 0
          }]
        }, {
          name: 'Prises de RDV',
          data: [{
            color: '#8BC34A',
            // color: this.Highcharts.getOptions().colors[1],
            radius: '87%',
            innerRadius: '63%',
            y: 0
          }]
        }, {
          name: 'Formulaires de contact',
          data: [{
            color: '#9E9E9E',
            // color: this.Highcharts.getOptions().colors[2],
            radius: '62%',
            innerRadius: '38%',
            y: 0
          }]
        }]
      }
    }
  },

  created () {
    // initialisation des options liées aux graphiques
    this.optionsTop10 = _.merge(this.optionsTop10, this.optionsPie)
    this.optionsAccueil = _.merge(this.optionsAccueil, this.optionsPie)
    this.optionsCta = _.merge(this.optionsCta, this.optionsPie)
    this.getAll()
  },

  methods: {
    /**
     * lance toutes les requêtes
     */
    getAll () {
      // affichage des loader
      this.loading = true
      this.queryCounter++
      Promise.all([
        this.getConversations(),
        this.getChatsDuration(),
        this.getNbMessages(),
        this.getNbQuestions(),
        this.getBotLogs()
      ])
      .then(() => {
        if (this.queryCounter === 1) {
          this.loading = false
          // execute les requetes messaging
          // this.getAllMessaging()
        }
        this.queryCounter--
      })
    },
    /**
     * Récupère le nombre de chats
     */
    getConversations () {
      return new Promise((resolve, reject) => {
        this.axios.get('get/chats_missed.php?' + this.params)
        .then(response => {
          this.chatsOK = response.data.chatsOK
          resolve()
        })
        .catch((e) => { reject(e) })
      })
    },
    /**
     * Récupère le temps de 1ere réponse
     */
    getBotLogs () {
      return new Promise((resolve, reject) => {
        this.axios.get('get/bot_logs.php?' + this.params)
        .then(response => {
          if (response.data.carousel === 0) {
            this.isThereCarrousel = false
          }
          if (response.data.cta === 0) {
            this.isThereCTA = false
          }
          if (response.data.transferts === 0) {
            this.isThereTransfert = false
          }
          if (!response.data.accueil || response.data.accueil === 0) {
            this.isThereAccueil = false
          }
          if (response.data.products === 0) {
            this.isThereTop10 = false
          }
          if (response.data.meeting === 0 && response.data.formok === 0 && response.data.c2c === 0) {
            this.isThereConversion = false
          }

          if (!this.isThereCarrousel || !this.isThereCTA || !this.isThereTransfert || !this.isThereAccueil || !this.isThereTop10 || !this.isThereConversion) {
            this.oneStatHidden = true
          }
          this.nbOpen = response.data.open
          this.nbDistinctOpen = response.data.distinctOpen

          this.nb_cta = response.data.cta
          this.nb_cart = response.data.cart
          this.nb_appel = response.data.appel
          this.nb_form = response.data.form
          this.nb_brochure = response.data.brochure
          this.nb_visio = response.data.visio
          this.nb_bonuseco = response.data.bonuseco
          this.nb_devis = response.data.devis

          this.nb_transfertchat = response.data.transfertchat
          this.nb_transferttel = response.data.transferttel
          this.nb_transfertemail = response.data.transfertemail
          this.nb_transfertmeeting = response.data.transfertmeeting

          this.nb_products = response.data.products
          this.nb_accueil = response.data.accueil
          this.nb_carousel = response.data.carousel

          this.nbVisWithCarrousel = response.data.visWithCarrousel
          this.nbCarouselsPerVis = response.data.carouselPerVis
          this.nb_transferts = response.data.transferts

          this.nb_formok = response.data.formok
          this.nb_meetingok = response.data.meeting
          this.nb_c2cok = response.data.c2c

          this.nb_like = response.data.like
          this.nb_unlike = response.data.unlike
          for (const id of response.data.likeDetails) {
            this.likesSessid.push(id)
          }
          for (const id of response.data.unlikeDetails) {
            this.unlikesSessid.push(id)
          }
          let top10 = Object.entries(response.data.top10)
          let idx = 1
          for (const [url, val] of top10) {
            if (idx === 1) {
              this.productConsult1 = url
              this.productConsultNb1 = val
            }
            if (idx === 2) {
              this.productConsult2 = url
              this.productConsultNb2 = val
            }
            if (idx === 3) {
              this.productConsult3 = url
              this.productConsultNb3 = val
            }
            if (idx === 4) {
              this.productConsult4 = url
              this.productConsultNb4 = val
            }
            if (idx === 5) {
              this.productConsult5 = url
              this.productConsultNb5 = val
            }
            if (idx === 6) {
              this.productConsult6 = url
              this.productConsultNb6 = val
            }
            if (idx === 7) {
              this.productConsult7 = url
              this.productConsultNb7 = val
            }
            if (idx === 8) {
              this.productConsult8 = url
              this.productConsultNb8 = val
            }
            if (idx === 9) {
              this.productConsult9 = url
              this.productConsultNb9 = val
            }
            if (idx === 10) {
              this.productConsult10 = url
              this.productConsultNb10 = val
            }
            idx++
          }

          let accueilDetails = Object.entries(response.data.accueilDetails)
          idx = 1
          for (const [msg, val] of accueilDetails) {
            if (idx === 1) {
              this.accueil1 = msg
              this.accueilNb1 = val
            }
            if (idx === 2) {
              this.accueil2 = msg
              this.accueilNb2 = val
            }
            if (idx === 3) {
              this.accueil3 = msg
              this.accueilNb3 = val
            }
            if (idx === 4) {
              this.accueil4 = msg
              this.accueilNb4 = val
            }
            idx++
          }

          // fromage des TOP10
          this.optionsTop10.series[0].data = [{
            name: this.productConsult1 + ' : ' + this.productConsultNb1 + ' fois',
            y: this.productConsultNb1
          }, {
            name: this.productConsult2 + ' : ' + this.productConsultNb2 + ' fois',
            y: this.productConsultNb2
          }, {
            name: this.productConsult3 + ' : ' + this.productConsultNb3 + ' fois',
            y: this.productConsultNb3
          }, {
            name: this.productConsult4 + ' : ' + this.productConsultNb4 + ' fois',
            y: this.productConsultNb4
          }, {
            name: this.productConsult5 + ' : ' + this.productConsultNb5 + ' fois',
            y: this.productConsultNb5
          }, {
            name: this.productConsult6 + ' : ' + this.productConsultNb6 + ' fois',
            y: this.productConsultNb6
          }, {
            name: this.productConsult7 + ' : ' + this.productConsultNb7 + ' fois',
            y: this.productConsultNb7
          }, {
            name: this.productConsult8 + ' : ' + this.productConsultNb8 + ' fois',
            y: this.productConsultNb8
          }, {
            name: this.productConsult9 + ' : ' + this.productConsultNb9 + ' fois',
            y: this.productConsultNb9
          }, {
            name: this.productConsult10 + ' : ' + this.productConsultNb10 + ' fois',
            y: this.productConsultNb10
          }]

          // fromage des Accueil
          this.optionsAccueil.series[0].data = [{
            name: this.accueil1 + ' : ' + this.accueilNb1 + ' fois',
            y: this.accueilNb1
          }, {
            name: this.accueil2 + ' : ' + this.accueilNb2 + ' fois',
            y: this.accueilNb2
          }, {
            name: this.accueil3 + ' : ' + this.accueilNb3 + ' fois',
            y: this.accueilNb3
          }, {
            name: this.accueil4 + ' : ' + this.accueilNb4 + ' fois',
            y: this.accueilNb4
          }]

          // fromage des CTA
          this.optionsCta.series[0].data = [{
            name: 'Panier : ' + this.nb_cart + ' fois',
            y: this.nb_cart
          }, {
            name: 'Demande d\'appel : ' + this.nb_appel + ' fois',
            y: this.nb_appel
          }, {
            name: 'Demande de contact (formulaire) : ' + this.nb_form + ' fois',
            y: this.nb_form
          }, {
            name: 'Demane de brochure : ' + this.nb_brochure + ' fois',
            y: this.nb_brochure
          }, {
            name: 'Contact en Visio : ' + this.nb_visio + ' fois',
            y: this.nb_visio
          }, {
            name: 'Bonus Eco : ' + this.nb_bonuseco + ' fois',
            y: this.nb_bonuseco
          }, {
            name: 'Demane de devis : ' + this.nb_devis + ' fois',
            y: this.nb_form
          }]

          // gauge
          let totalTransf = this.nb_transfertchat + this.nb_transferttel + this.nb_transfertemail + this.nb_transfertmeeting
          this.graphTransfert.series[0].data[0].y = Math.round(this.nb_transfertchat * 100 / totalTransf)
          this.graphTransfert.series[1].data[0].y = Math.round(this.nb_transferttel * 100 / totalTransf)
          this.graphTransfert.series[2].data[0].y = Math.round(this.nb_transfertemail * 100 / totalTransf)
          this.graphTransfert.series[3].data[0].y = Math.round(this.nb_transfertmeeting * 100 / totalTransf)

          // gauge
          let totalConversion = this.nb_c2cok + this.nb_meetingok + this.nb_formok
          if (totalConversion !== 0) {
            this.graphConversion.series[0].data[0].y = Math.round(this.nb_c2cok * 100 / totalConversion)
            this.graphConversion.series[1].data[0].y = Math.round(this.nb_meetingok * 100 / totalConversion)
            this.graphConversion.series[2].data[0].y = Math.round(this.nb_formok * 100 / totalConversion)
          }
          if (this.nb_carousel !== 0) {
            this.jaugeCarousels.series[0].data[0] = Math.round(this.nbVisWithCarrousel * 100 / this.nb_carousel)
          }
          this.jaugeCarousels.yAxis.title.text = ''

          resolve()
        })
        .catch((e) => { reject(e) })
      })
    },
    /**
     * Récupère les durées des chats
     */
    getChatsDuration () {
      return new Promise((resolve, reject) => {
        this.axios.get('get/chats_duration.php?' + this.params)
        .then(response => {
          // mise à jour du graphique avec les données récupérées
          this.chatsTotalDuration = response.data.dureeTotale
          this.chatsAverageDuration = response.data.dureeMoyenne
          resolve()
        })
        .catch((e) => { reject(e) })
      })
    },
    /**
     * Récupère le nombre de messages échangés
     */
    getNbMessages () {
      return new Promise((resolve, reject) => {
        this.axios.get('get/agents_nb_messages.php?' + this.params)
        .then(response => {
          // mise à jour des données récupérées
          let totalBulles = response.data.nbBulles
          if (this.chatsOK !== '0') {
            this.nbMessages = (totalBulles / this.chatsOK).toFixed(1)
          }
          resolve()
        })
        .catch((e) => { reject(e) })
      })
    },
    /**
     * Récupère le nombre de question des visiteurs
     */
    getNbQuestions () {
      return new Promise((resolve, reject) => {
        this.axios.get('get/vis_nb_questions.php?' + this.params)
        .then(response => {
          // mise à jour des données récupérées
          this.nbQuestions = response.data.nb_questions
          this.nbCherche = response.data.nb_cherche

          // gauge
          this.graphOpening.series[0].data[0].y = Math.round(this.nbOpen * 100 / this.nbDistinctOpen)
          this.graphOpening.series[1].data[0].y = Math.round(this.nbQuestions * 100 / this.nbDistinctOpen)
          this.graphOpening.series[2].data[0].y = Math.round(this.nbCherche * 100 / this.nbDistinctOpen)

          resolve()
        })
        .catch((e) => { reject(e) })
      })
    },
    download () {
      this.loadingExportData = true
      let csv = null
      const fields = [
        'conversations',
        'duration',
        'messages',
        'consults',
        'uniques',
        'questions',
        'carrousels',
        'carrouselrecu',
        'produits',
        'top1',
        'top2',
        'top3',
        'top4',
        'top5',
        'top6',
        'top7',
        'top8',
        'top9',
        'top10',
        'transferts',
        'transfertlivechat',
        'transfertcallback',
        'transfertmeeting',
        'formulaire',
        'convertions',
        'convertionscallback',
        'convertionsmeeting',
        'convertionsformulaire',
        'likes',
        'unlikes',
        'cta',
        'brochure',
        'devis',
        'recontacter',
        'panier',
        'visio',
        'appel',
        'bonus'
      ]
      const fieldNames = [
        'conversations',
        'durée moyenne des conversations',
        'messages par conversation',
        'Chatbots consultés',
        'Nb Visiteurs uniques',
        'Nb questions',
        'Carrousels proposés',
        'Visiteurs ayant recu carrousel',
        'Produits consultés',
        'Top 1 visité',
        'Top 2 visité',
        'Top 3 visité',
        'Top 4 visité',
        'Top 5 visité',
        'Top 6 visité',
        'Top 7 visité',
        'Top 8 visité',
        'Top 9 visité',
        'Top 10 visité',
        'Nb transferts',
        'Transferts livechat',
        'Transferts callback',
        'Transferts meeting',
        'Transferts formulaire',
        'Convertions totale',
        'Convertions callback',
        'Convertions meeting',
        'Convertions formulaire',
        'Nb likes',
        'Nb unlikes',
        'CTA cliqués',
        'CTA brochure',
        'CTA devis',
        'CTA recontacter',
        'CTA panier',
        'CTA visio',
        'CTA appel',
        'CTA bonus eco'
      ]
      const data = {
        conversations: this.chatsOK,
        duration: this.chatsAverageDuration,
        messages: this.nbMessages,
        consults: this.nbOpen,
        uniques: this.nbDistinctOpen,
        questions: this.nbQuestions,
        carousels: this.nb_carousel,
        visiteurAvecCarrousel: this.nbVisWithCarrousel,
        nbCarrouselParVis: this.nbCarouselsPerVis,
        produits: this.nb_products,
        top1: this.productConsult1,
        top2: this.productConsult2,
        top3: this.productConsult3,
        top4: this.productConsult4,
        top5: this.productConsult5,
        top6: this.productConsult6,
        top7: this.productConsult7,
        top8: this.productConsult8,
        top9: this.productConsult9,
        top10: this.productConsult10,
        transferts: this.nb_transferts,
        transfertlivechat: this.nb_transfertchat,
        transfertcallback: this.nb_transferttel,
        transfertmeeting: this.nb_transfertmeeting,
        formulaire: this.nb_transfertemail,
        convertions: this.nb_formok + this.nb_c2cok + this.nb_meetingok,
        convertionscallback: this.nb_c2cok,
        convertionsmeeting: this.nb_meetingok,
        convertionsformulaire: this.nb_formok,
        likes: this.nb_like,
        unlikes: this.nb_unlike,
        cta: this.nb_cta,
        brochure: this.nb_brochure,
        devis: this.nb_devis,
        recontacter: this.nb_form,
        panier: this.nb_cart,
        visio: this.nb_visio,
        appel: this.nb_appel,
        bonus: this.nb_bonuseco
      }
      try {
        csv = json2csv({ data, fields, del: ';', fieldNames })
      } catch (err) {
        this.loadingExportData = false
        return
      }

      // téléchargement du fichier csv
      var hiddenElement = document.createElement('a')
      hiddenElement.href = 'data:attachment/text,' + encodeURI(csv)
      hiddenElement.target = '_blank'
      hiddenElement.download = 'chatbotAI.csv'
      document.body.appendChild(hiddenElement)
      hiddenElement.click()
      this.loadingExportData = false
    },
    getChats () {
      if (this.histoready) {
        this.histoready = false
      } else {
        this.histoready = true
      }
    },
    showChats () {
      this.filterChats = false
      this.getChats()
    },
    filterShortChats () {
      this.filterChats = true
      this.getChats()
    },
    displayAllStats () {
      this.isThereCarrousel = true
      this.isThereCTA = true
      this.isThereTransfert = true
      this.isThereAccueil = true
      this.isThereTop10 = true
      this.isThereConversion = true
    }
  },

  computed: {
    ...mapGetters('_Stats', ['params']),
    ...mapState('_User', ['entLevel']),
    heightOfJauge () {
      return this.optionsJauge.chart.height + 'px'
    },
    totalDurationFormatted () {
      return moment.duration(this.chatsTotalDuration, 'seconds').format('h[h] m[m] s[s]')
    },
    averageDurationFormatted () {
      return moment.duration(this.chatsAverageDuration, 'seconds').format('h[h] m[m] s[s]')
    }
  },

  watch: {
    params (v) {
      this.getAll()
    }
  }
}
</script>
<style>
.fixed-height-list {
  max-height: 280px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/stats/ChatbotAI.vue